





























import {
  Component, Vue,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('user');

@Component
export default class PreNotificationPopover extends Vue {
  @userModule.Getter('getGuideOptions') guideOptions: any;

  @userModule.Action('saveOption') handleSaveOption: any;

  private showAnimate: boolean = false

  private show: boolean = true

  private first: boolean = false

  private timer: any = null

  private cutDown: any = {
    totalTime: 5,
    timer: null,
    time: 0,
  }

  private handleOk(): void {
    if (this.first) return;
    this.showAnimate = true;
    const { guideScoreOffline } = this.guideOptions;
    if (guideScoreOffline && guideScoreOffline.isOption === 0) {
      this.handleSaveOption(guideScoreOffline.code);
    }
    setTimeout(() => {
      this.show = false;
      this.showAnimate = false;
      this.$nextTick(() => {
        this.$bus.$emit('guideScoreOffline', 1);
      });
    }, 300);
  }

  private _cutDown() {
    if (this.cutDown.timer) { clearInterval(this.cutDown.timer); }
    this.cutDown.time = this.cutDown.totalTime;
    this.cutDown.timer = setInterval(() => {
      if (this.cutDown.time > 0) {
        this.cutDown.time -= 1;
      } else {
        if (this.cutDown.timer) { clearInterval(this.cutDown.timer); }
        this.first = !this.first;
      }
    }, 1000);
  }

  mounted() {
    const { guideScoreOffline } = this.guideOptions;
    this.$bus.$on('showGuideScoreOffline', () => {
      this.show = true;
    });
    if (guideScoreOffline && guideScoreOffline.isOption === 0) {
      this.$nextTick(() => {
        this.$bus.$emit('guideScoreOffline', 0);
      });
      this.first = true;
      this._cutDown();
    } else {
      this.show = false;
    }
  }
}
